import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		defaultMessage: 'New product added',
		id: 'atlassian-switcher-common-integration-view.integration-popup.app-switcher-nudge-tooltip.heading',
		description:
			'Describes the heading of the tooltip that appears when a new product is added to the site.',
	},
	confluenceContent: {
		defaultMessage:
			"Someone in your team has just started using Confluence. It's been added to your site for free.",
		id: 'atlassian-switcher-common-integration-view.integration-popup.app-switcher-nudge-tooltip.confluence-content',
		description: 'Description of the tooltip that appears when a new product is added to the site.',
	},
	jsmContent: {
		defaultMessage:
			"Someone in your team has just started using Jira Service Management. It's been added to your site for free.",
		id: 'atlassian-switcher-common-integration-view.integration-popup.app-switcher-nudge-tooltip.jsm-content',
		description: 'Description of the tooltip that appears when a new product is added to the site.',
	},
	jpdContent: {
		defaultMessage:
			"Someone in your team has just started using Jira Product Discovery. It's been added to your site for free.",
		id: 'atlassian-switcher-common-integration-view.integration-popup.app-switcher-nudge-tooltip.jpd-content',
		description: 'Description of the tooltip that appears when a new product is added to the site.',
	},
	confluenceAndJsmPrimaryButtonText: {
		defaultMessage: 'Take a tour',
		id: 'atlassian-switcher-common-integration-view.integration-popup.app-switcher-nudge-tooltip.confluence-and-jsm-primary-button-text',
		description:
			'Label for the confluence and jsm primary button in the tooltip that appears when a new product is added to the site.',
	},
	jpdPrimaryButtonText: {
		defaultMessage: 'Show details',
		id: 'atlassian-switcher-common-integration-view.integration-popup.app-switcher-nudge-tooltip.jpd-primary-button-text',
		description:
			'Label for the jpd primary button in the tooltip that appears when a new product is added to the site.',
	},
	secondaryAction: {
		defaultMessage: 'Dismiss',
		id: 'atlassian-switcher-common-integration-view.integration-popup.app-switcher-nudge-tooltip.secondary-action',
		description:
			'Label for the secondary action in the tooltip that appears when a new product is added to the site.',
	},
});
